import { TAX_DETAILS_STATUS } from "../TaxDetails.consts";
import type {
  TaxDetailsStatus,
  TaxDetailsStatusPillVariant,
} from "../TaxDetails.types";

/** Pill colour per status. Statuses absent from this map render no pill. */
const TAX_DETAILS_STATUS_PILL_VARIANTS: Partial<
  Record<TaxDetailsStatus, TaxDetailsStatusPillVariant>
> = {
  [TAX_DETAILS_STATUS.pending]: "yellow",
  [TAX_DETAILS_STATUS.validated]: "green",
  [TAX_DETAILS_STATUS.invalid]: "red",
};

export { TAX_DETAILS_STATUS_PILL_VARIANTS };
